import { Box, Button, Container, Typography } from "@mui/material";
import { ROUTE_COMPLETE_PROFILE, ROUTE_PROFILER } from "../../constants/routes";
import { useLocation, useNavigate } from "react-router-dom";

const Image = ({ src, alt, style }: any) => <Box component="img" src={src} alt={alt} style={style} loading="lazy" />;

const getRandomPosition = () => ({
  left: `${Math.random() * 100}vw`,
  top: `${Math.random() * 100}vh`,
});

const VideoComplete = () => {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <Container
      sx={{
        position: "relative",
        width: "100vw",
        minHeight: "100vh", // Allows the container to stretch
        backgroundColor: "#756DE9",
        overflowY: "auto", // Enable scrolling
        display: "flex",
        flexDirection: "column", // Stack content vertically
        alignItems: "center",
        padding: "20px", // Padding to avoid content hitting the edges
      }}
    >
      <Box
        sx={{
          position: "relative",
          top: 20,
          width: 77,
          height: 40,
        }}
      >
        <Image src="/images/Seevi-Logo-White.png" alt="Seevi Logo" style={{ width: 77, height: 40 }} />
      </Box>

      <Box
        sx={{
          position: "absolute",
          right: 0,
          top: 30,
        }}
      >
        <Image src="/images/Clap4.png" alt="Image 1" style={{ width: 138.55, height: 285.33 }} />
      </Box>
      <Box
        sx={{
          position: "absolute",
          left: 0,
          bottom: 0,
        }}
      >
        <Image src="/images/Page-1.png" alt="Image 2" style={{ width: 170.7, height: 292.59 }} />
      </Box>
      <Box sx={{ position: "absolute", ...getRandomPosition() }}>
        <Image src="/images/Ellipse-10.png" alt="Image 1" style={{ width: "10px", height: "10px" }} />
      </Box>
      <Box sx={{ position: "absolute", ...getRandomPosition() }}>
        <Image src="/images/Ellipse-15.png" alt="Image 2" style={{ width: "10px", height: "10px" }} />
      </Box>
      <Box sx={{ position: "absolute", ...getRandomPosition() }}>
        <Image src="/images/Ellipse-16.png" alt="Image 3" style={{ width: "12px", height: "12px" }} />
      </Box>
      <Box sx={{ position: "absolute", ...getRandomPosition() }}>
        <Image src="/images/Ellipse-20.png" alt="Image 4" style={{ width: "8px", height: "8px" }} />
      </Box>
      <Box sx={{ position: "absolute", ...getRandomPosition() }}>
        <Image src="/images/Ellipse-21.png" alt="Image 5" style={{ width: "9px", height: "9px" }} />
      </Box>
      <Box sx={{ position: "absolute", ...getRandomPosition() }}>
        <Image src="/images/Ellipse-22.png" alt="Image 6" style={{ width: "6px", height: "6px" }} />
      </Box>
      <Box sx={{ position: "absolute", ...getRandomPosition() }}>
        <Image src="/images/Ellipse-23.png" alt="Image 7" style={{ width: "8px", height: "8px" }} />
      </Box>

      <Box sx={{ textAlign: "center", marginTop: "auto" }}>
        <Typography variant="h4" sx={{ color: "white", fontWeight: "600", fontSize: "30px" }}>
          Well Done!
        </Typography>
        <Typography variant="h6" sx={{ color: "white", fontWeight: "medium", mt: 2, fontSize: "18px" }}>
          Your Video is under surveillance scan. Videos will reflect in your account within 12 hours.
        </Typography>
      </Box>

      <Box
        sx={{
          width: "100%",
          textAlign: "center",
          marginTop: "auto", // Aligns the button at the bottom
          paddingBottom: "15px",
        }}
      >
        <Button
          sx={{
            fontWeight: 600,
            backgroundColor: "white",
            borderRadius: "99px",
            fontSize: "16px",
            textTransform: "capitalize",
            width: "90%",
            color: "#756DE9",
            "&:hover": {
              backgroundColor: "#f5f5f5",
            },
            padding: "15px 40px",
          }}
          variant="contained"
          size="small"
          onClick={() =>
            location?.search?.includes("edit") ? navigate(ROUTE_COMPLETE_PROFILE) : navigate(ROUTE_PROFILER)
          }
        >
          Got It!
        </Button>
      </Box>
    </Container>
  );
};

export default VideoComplete;
